import UserSolidSVG from "@design-system/ui-icons/vanilla/UserSolid"
import { createIcon } from "../createIcon"

export const UserSolidIcon = createIcon(UserSolidSVG)
